import { Avatar, Box, Button, styled, Typography } from '@mui/material';

export const Body = styled(Box)(({ theme }) => ({
  borderRadius: '50%',
  width: '72px',
  minWidth: '72px',
  height: '72px',
  padding: '7px',
  marginBottom: '1rem',
  position: 'relative',
  cursor: 'pointer',
}));

export const BodyWithBorder = styled(Body)(({ theme }) => ({
  border: '3px solid #BC9E31',
}));

export const BodyWithGrayBorder = styled(Body)(({ theme }) => ({
  border: '3px solid #413F4F',
}));

export const CustomAvatar = styled(Avatar)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundColor: 'gre',
}));

export const TitleText = styled(Typography)(({ theme }) => ({
  color: '#52505F',
  fontSize: '.9rem',
  textAlign: 'center',
  marginTop: '1rem',
}));

export const SmallIconButton = styled(Button)(({ theme }) => ({
  padding: '12px',
  border: '5px solid',
  minWidth: '25px',
  width: '25px',
  height: '25px',
  borderRadius: '50%',
  position: 'absolute',
  bottom: '0',
  right: '0',
  backgroundColor: '#36899F',
  '&:hover': {
    backgroundColor: '#36899F',
  },
}));
